/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Grant} from '../models/Grant';

export interface SearchGrants$Request {
    grantName: string;
}

export interface SearchGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchGrantsRequest = createAction<PayloadData<void, SearchGrants$Request>>('ENTITLEMENTS_GRANTS_SEARCH__SEARCH_GRANTS__REQUEST');
export const searchGrantsSuccess = createAction<PayloadData<Array<Grant>, SearchGrants$Request>>('ENTITLEMENTS_GRANTS_SEARCH__SEARCH_GRANTS__SUCCESS');
export const searchGrantsFailure = createAction<PayloadData<Error, SearchGrants$Request, true>>('ENTITLEMENTS_GRANTS_SEARCH__SEARCH_GRANTS__FAILURE');

export const searchGrantsActions = [
    searchGrantsRequest,
    searchGrantsSuccess,
    searchGrantsFailure
] as const;

/**
 * @param {string} meta.grantName
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchGrants = (meta: SearchGrants$Request, config?: SearchGrants$Config) => {
    const TRANSPORT_GET_PARAMS = {
        grantName: meta.grantName,
    };
    return {
        CALL_API: {
            types: searchGrantsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/grants/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

